export default __webpack_public_path__ + "static/media/Widowdusk Arm-straps.52c7902b.jpg";